<template>
  <div class="c-table__cell-value with-description-cell">
    <template v-if="descriptionModel && descriptionModel.hasDescription">
      <a href="javascript:void(0)" @click="$emit('showDescription', descriptionModel)">{{ value }}</a>
    </template>
    <template v-else>
      {{ value }}
    </template>
  </div>
</template>

<script>
export default {
  name: "discipline-amount-cell",
  props: ["value", "descriptionModel"],
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.discipline-amount-cell {
  line-height: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  text-align: right;
  padding: 10px !important;
  -webkit-transition: font 0.3s ease;
  transition: font 0.3s ease;

  @media screen and (max-width: 700px) {
    justify-content: flex-start;
  }

  &-up {
    display: inline-block;
    margin-left: -5px;
  }

  & span {
    margin-left: 20px;

    @media screen and (max-width: 700px) {
      margin-left: 0;
    }
  }

  &-green {
    color: #12c971;
  }

  &-red {
    color: #ff238d;
  }
}
</style>
